import styled from 'styled-components';
import { FlexBetween, FlexColumn } from '../../../../../styled/common';
import { Breakpoints } from '../../../../../styled/constants';

export const InfoBlock = styled(FlexColumn)`
  display: none;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: flex;
    gap: 20px;
    width: 310px;
    height: max-content;
    max-width: 100%;
    flex: 0 0 310px;
    padding: 20px;
    border-radius: 14px;
    background-color: ${({ theme }) => theme.colors.background.tertiary};
  }
`;

export const InfoContainer = styled(FlexColumn)`
  gap: 10px;
  padding: 10px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.border.secondary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};
`;

export const InfoItem = styled(FlexBetween)`
  gap: 5px;

  &:nth-of-type(3) {
    span:nth-of-type(2) {
      text-transform: lowercase;
    }
  }
`;
